<template>
  <span>
    <b-button
      @click="openModal"
      variant="primary"
      size="sm"
      class="p-0 px-2 ml-1"
      ><i class="ri-pencil-line"></i
    ></b-button>

    <b-modal :id="gen_id" title="Change days" hide-footer>
      <FormulateForm
        class="flat-rate-form"
        @submit="changeFlatValue"
        v-model="formValues"
      >
        <FormulateInput
          name="no_of_days"
          type="number"
          label="Number of days"
          validation="required"
        />
        <div class="text-right">
          <FormulateInput
            type="submit"
            :label="changing ? 'Changing...' : 'Change'"
          />
        </div>
      </FormulateForm>
    </b-modal>
  </span>
</template>

<script>
import { campaigns } from "@/config/api/campaigns";
import idGen from "@/utils/idGen";
export default {
  props: ["data"],
  data() {
    return {
      formValues: {},
      changing: false,
      idGen: idGen,
    };
  },
  methods: {
    changeFlatValue() {
      const api = campaigns.changeIndividualNoOfDays;
      api.data = {
        campaignAdId: this.data.ad_id,
        no_of_days: this.formValues.no_of_days,
      };
      this.changing = true;
      this.generateAPI(api)
        .then((res) => {
          this.$emit(
            "change",
            this.data.id,
            this.data.is_current_ad,
            res.data.ad.no_of_days
          );
          this.$bvToast.toast("Number of days are changed!", {
            title: "No. Days",
            variant: "success",
            solid: true,
          });
        })
        .catch((err) => {
          this.$bvToast.toast(
            `No. days are not changed!, ${err.response.data.error}`,
            {
              title: "No. Days",
              variant: "danger",
              solid: true,
            }
          );
        })
        .finally(() => {
          this.changing = false;
        });
    },
    openModal() {
      this.formValues.no_of_days = this.data.no_of_days;
      this.$bvModal.show(`${this.gen_id}`);
    },
  },
  computed: {
    gen_id() {
      return `day-change-modal-${this.data.ad_id}`;
    },
  },
};
</script>

<style></style>
